module.exports = __webpack_public_path__ + "static/img/17.8bf5fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/17.png
// module id = P1Yd
// module chunks = 0